import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './mine.component.html',
  styleUrls: ['./mine.component.css'],
})
export class MineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
